module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAASUlEQVQ4y2NgGCSg4T8Ig0B9/f7/MD5hTMCAhoYDeDFc+38yAdwAkK0gDHMBDFPsBaJdQHEgUhwGxNtIKxcQim+C6YBiLwxtAAA9/pX22K5RTQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/GR.png
// module id = 1153
// module chunks = 0